import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import html2canvas from 'html2canvas';
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import { Modal, ModalBody } from "react-bootstrap";
import { enumUtil } from './Enum';
import { ServerRequestPublic } from './ServerDataRequest';
import isNull from './NullChecking';

const fontOptions = [
    'Sacramento',
    'Great-Vibes',
    'Herr-Von-Muellerhoff',
    'Allura',
    'Zeyada',
    'Mr-Dafoe',
    'Water-Brush',
    'Handlee',
    'Kristi',
    'Mrs-Saint-Delafield',
    'Taprom'
];

let textColors = ['#333333', 'var(--BlueColor)', '#F1383B', '#5AB461']
const SignatureConsentForm = forwardRef((props, ref) => {
    const { name, activeTab, setActiveTab, setSearchParam, setIsSign, setIsLoading, getSaveData } = props;
    console.log("props?.", props)

    const { coSignItemData, isToBeCoSignedStatus, setSaveEncounterCoSignData, isOpenedFrom: isOpenedFromCoSignProp } = props?.coSignProps || {};
    const isSignatureCoSign = isOpenedFromCoSignProp === 'CoSign' && isToBeCoSignedStatus;
    let nameText = isSignatureCoSign ? (coSignItemData?.ProviderName || 'Provider Name') : name;
    // console.log("propsname", nameText, "isSignatureCoSign", isSignatureCoSign, "coSignItemData", coSignItemData?.ProviderName)

    // const [typedSignature, setTypedSignature] = useState('');
    // const [selectedFont, setSelectedFont] = useState('Pacifico');
    const [isEmpty, setIsEmpty] = useState(true);
    const [uploadedImage, setUploadedImage] = useState(null);
    const [fontType, setFontType] = useState('Sacramento');
    const [textSelectedType, setTextSelectedType] = useState('Name');
    const [textColorIndex, setTextColorIndex] = useState(0);
    const [text, setText] = useState('')

    const sigRef = useRef(null);
    const selectedFontRef = useRef(null);
    const uploadRef = useRef(null);

    const [isDefaultSignature, setIsDefaultSignature] = useState(false);

    // Expose these methods to parent
    useImperativeHandle(ref, () => ({
        saveDrawnSignature,
        saveTypedSignature,
        saveUploadedSignature
    }));

    const handleSetCoSign = (filename, base64) => {
        setSaveEncounterCoSignData([{
            ...coSignItemData,
            SignatureFileName: filename,
            SignaturePath: base64,
            EncounterStatus: 'Signed',
            IsLinkedProviderSignature: 'false',
        }])
    }

    const downloadImage = (dataURL, filename = 'signature.png') => {
        const base64 = dataURL.split("base64,")[1];
        console.log("PatientAppointmentIDPatientAppointmentID", base64);
        if (signExists) {
            // setSearchParam(prev => ({
            //     ...prev,
            //     EncounterStatus: 'Signed'
            // }));
        } else {
            if (isSignatureCoSign) {
                // Co-Sign signature doesnt exist in Provider case
                handleSetCoSign(filename, base64);
            } else {
                setSearchParam(prev => ({
                    ...prev,
                    SignatureFileName: filename,
                    SignaturePath: base64,
                    EncounterStatus: 'Signed',
                    IsLinkedProviderSignature: 'false',
                }));
                
            }
        }
        // setSearchParam(prev => ({
        //     ...prev,
        //     SignatureFileName: filename,
        //     SignaturePath: base64,
        //     EncounterStatus: 'Signed'
        // }));
        setIsLoading(false);
        setIsSign(false);
        console.log("props?.isOpenedFrom", props?.isOpenedFrom, props?.isOpenedFrom === "PatientIntakeForm")
        if (props?.isOpenedFrom === "PatientIntakeForm") {
            getSaveData(props?.item, filename, base64);
        } else if (props?.isOpenedFrom === "AddNewProvider") {
            getSaveData("", filename, base64);
        } else if (props?.isOpenedFrom === "EncounterMenuBulk") {
            getSaveData("", filename, base64, 'SignatureMissing');
        }
        else if (props?.isOpenedFrom === "User") {
            getSaveData("", filename, base64, 'SignatureMissing');
        }
        else if (props?.isOpenedFrom === "PatientDefaultSignature") {
            getSaveData(props?.item, filename, base64, {
                type: 'PatientDefaultSignature',
                isDefaultSignature: isDefaultSignature,
            });
        } else {
            getSaveData("", "", "", 'Save Sign');
        }
        // const link = document.createElement('a');
        // link.href = dataURL;
        // link.download = filename;
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
    };

    const handleUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            setUploadedImage(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const saveDrawnSignature = () => {
        if (!sigRef.current) return;
        const dataURL = sigRef.current.getTrimmedCanvas().toDataURL('image/png');
        downloadImage(dataURL, 'drawn-signature.png');
    };

    const handleClearDrawnSignature = () => {
        if (sigRef.current) {
            sigRef.current.clear();
        }
    }
    const generateSignatureFromDOM = async (el) => {
        //read DOM data
        const styles = getComputedStyle(el);

        const scale = 1;
        // create canvas
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const width = el.offsetWidth;
        const height = el.offsetHeight;

        // high resolution
        canvas.width = width * scale;
        canvas.height = height * scale;

        ctx.scale(scale, scale);

        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";

        const fontSize = parseFloat(styles.fontSize);
        const fontFamily = styles.fontFamily;
        const fontWeight = styles.fontWeight;
        const color = styles.color;

        await document.fonts.load(`${fontWeight} ${fontSize}px ${fontFamily}`);

        // background
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, width, height);

        // text styles
        ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
        ctx.fillStyle = color;
        ctx.textAlign = "center";

        // FIX: accurate vertical centering using font metrics
        const metrics = ctx.measureText(el.innerText);

        const actualHeight =
            metrics.actualBoundingBoxAscent +
            metrics.actualBoundingBoxDescent;

        const y =
            (height + actualHeight) / 2 - metrics.actualBoundingBoxDescent;

        ctx.fillText(el.innerText, width / 2, y);

        return canvas.toDataURL("image/png");
    };
    const saveTypedSignature = async () => {
        console.log("saveTypedSignature start")
        ///////// Old Flow/////////
        // if (!selectedFontRef.current) return;
        // const canvas = await html2canvas(selectedFontRef.current);
        // const dataURL = canvas.toDataURL('image/png');
        ///////////////////
        const dataURL = await generateSignatureFromDOM(selectedFontRef.current);
        downloadImage(dataURL, 'typed-signature.png');
    };
    const getFileTypeFromBase64 = (base64String) => {
        const match = base64String.match(/^data:(.+);base64,/);
        return match ? match[1] : null;
    };

    const getExtensionFromMime = (mimeType) => {
        const map = { 'image/png': 'png', 'image/jpeg': 'jpg', 'image/jpg': 'jpg' };
        return map[mimeType] || 'png'; // default to png if unknown
    };
    const saveUploadedSignature = () => {
        if (uploadedImage) {
            const mimeType = getFileTypeFromBase64(uploadedImage);
            const extension = getExtensionFromMime(mimeType);
            downloadImage(uploadedImage, `uploaded-signature.${extension}`);
        }
    };

    const handleColor = (index) => {
        // if(!colors?.[index]) return;

        setTextColorIndex(index);
    }

    const handleChange = (e) => {
        let value = e.target.value;
        // allow alphabets + spaces only
        value = value.replace(/[^a-zA-Z\s]/g, '');
        setText(value)
    }

    let textUserName = useMemo(() => {
        if (!nameText) return '';
        let fullName = nameText;
        let initials = fullName?.trim().split(/\s+/).map(word => word[0].toUpperCase()).join('');
        return (textSelectedType === 'Name' ? fullName : initials);
    }, [nameText, textSelectedType])
    const displayText = text?.trim() || textUserName;
    // console.log("textUserName", text?.trim(), Boolean(text?.trim()), 'D', displayText)
    const signExists = isSignatureCoSign ? coSignItemData?.ProviderSignaturePath : !!props?.initialDataData?.ProviderSignaturePath;
    const isOpenedFromEncounter = !(["PatientIntakeForm", "AddNewProvider", 'User', 'PatientDefaultSignature'].includes(props?.isOpenedFrom));
    const bucketPath = isSignatureCoSign ? coSignItemData?.ProviderSignaturePath : (props?.initialDataData?.ProviderSignaturePath || '')
    const signPreviewInitialData = isSignatureCoSign ? coSignItemData : props?.initialDataData;

    // console.log("isSignatureCoSign", isSignatureCoSign, isOpenedFromCoSignProp === 'CoSign' , isToBeCoSignedStatus)
    return (
        <>
            <div className="ar-sign-tab">
                {signExists ?
                    <SignPreview initialDataData={signPreviewInitialData} BucketPath={bucketPath} setIsLoading={setIsLoading} /> :
                    <>
                        {isOpenedFromEncounter ?
                            <div className='ar-alert d-flex gap-1 mt-0-5 mb-12 mx-10'>
                                <i className='icon-alert'></i>
                                <p className='text fs-11 fst-italic'>Signature will be saved to your profile and used for future encounters. you can update it anytime. </p>
                            </div> : <></>}
                        <Tab.Container activeKey={activeTab} onSelect={(tab) => setActiveTab(tab)}>
                            <Nav variant="tabs" className="d-flex border-0 gx-0 px-10 align-items-center gap-15 mb-12">
                                <Nav.Item>
                                    <Nav.Link eventKey="Type" className="text fs-13 ar-light-color p-0">Type</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="Draw" className="text fs-13 ar-light-color p-0">Draw</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="Upload" className="text fs-13 ar-light-color p-0">Upload</Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <Tab.Content>
                                <Tab.Pane eventKey='Type'>
                                    <div className="p-2 d-flex flex-column gap-12 ar_content">
                                        <div className="d-flex align-items-end justify-content-between gap-25">
                                            <div className="d-flex align-items-center gap-10 w-100">
                                                <div className="input w-100">
                                                    <label htmlFor="FirstName" className='mb-3px'>Enter Your Signature</label>
                                                    <input type="text"
                                                        className='form-control'
                                                        name="FirstName"
                                                        id="FirstName"
                                                        autoComplete="off"
                                                        onChange={handleChange}
                                                        value={text}
                                                        maxLength={19}
                                                    />
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center gap-6">
                                                {Array.from({ length: 4 }).map((_, index) => (
                                                    <div className={`ar-box d-flex align-items-center justify-content-center ${textColorIndex === index ? 'active' : ''}`} onClick={() => handleColor(index)}>
                                                        <i className="icon-check fs-12 opacity-0"></i>
                                                    </div>

                                                ))}
                                            </div>
                                        </div>
                                        {/* <div className="d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center gap-10">
                                                <label className="ar_radio-btn d-flex align-items-center gap-6">
                                                    <input
                                                        type="radio"
                                                        name="Name"
                                                        checked={textSelectedType === 'Name'}
                                                        onChange={() => setTextSelectedType('Name')}
                                                    />
                                                    <span className="text ar-orange-text">Name</span>
                                                </label>
                                                <label className="ar_radio-btn d-flex align-items-center gap-6">
                                                    <input
                                                        type="radio"
                                                        name="Initials"
                                                        checked={textSelectedType === 'Initials'}
                                                        onChange={() => setTextSelectedType('Initials')}
                                                    />
                                                    <span className="text ar-orange-text">Initials</span>
                                                </label>
                                            </div>
                                            <div className="d-flex align-items-center gap-6">
                                                {Array.from({ length: 4 }).map((_, index) => (
                                                    <div className={`ar-box d-flex align-items-center justify-content-center ${textColorIndex === index ? 'active' : ''}`} onClick={() => handleColor(index)}>
                                                        <i className="icon-check fs-12 opacity-0"></i>
                                                    </div>

                                                ))}
                                            </div>
                                        </div> */}
                                        <p className='heading'>Select Typeface:</p>
                                        <div className="ar-signature-selction hover-scrollbar">
                                            {fontOptions.map((font) => (
                                                <div
                                                    // ref={fontType === font ? selectedFontRef : null} 
                                                    className={`text fs-18 typeface-box fw-400 cursor-pointer user-select-none validation_message ${font} ${fontType === font ? 'active' : ''} ${textColors?.[textColorIndex]}`} style={{ color: textColors?.[textColorIndex] }} onClick={() => setFontType(font)}>{displayText}</div>
                                            ))}
                                        </div>
                                        {/* // selected element for image capture, not in view // */}
                                        <div
                                            ref={selectedFontRef}
                                            className={`d-flex align-items-center justify-content-center text fs-22 typeface-box fw-600 cursor-pointer user-select-none w-max-content ${fontType} ${textColors?.[textColorIndex]}`}
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: '-9999px',
                                                color: textColors?.[textColorIndex]
                                            }}>
                                            {displayText}
                                        </div>

                                        {/* <button onClick={saveTypedSignature}> Save</button> */}
                                    </div>
                                </Tab.Pane>

                                <Tab.Pane eventKey='Draw'>
                                    <div className="p-2 d-flex flex-column gap-12 ar_content">
                                        <div className="d-flex align-items-center justify-content-between gap-6">
                                            <div className='fs-13 ar-light-color text cursor-pointer' onClick={handleClearDrawnSignature}>Clear</div>
                                            <div className="d-flex align-items-center gap-6 justify-content-end">
                                                {Array.from({ length: 4 }).map((_, index) => (
                                                    <div className={`ar-box d-flex align-items-center justify-content-center ${textColorIndex === index ? 'active' : ''}`} onClick={() => handleColor(index)}>
                                                        <i className="icon-check fs-12 opacity-0"></i>
                                                    </div>

                                                ))}
                                            </div>
                                        </div>
                                        <div className="">
                                            <SignatureCanvas
                                                ref={sigRef}
                                                penColor={textColors?.[textColorIndex]}
                                                onBegin={() => setIsEmpty(false)}
                                                canvasProps={{ height: 196, width: 402, className: 'bg-transparent', }}
                                            />
                                            {/* Placeholder */}
                                            {isEmpty && (
                                                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', pointerEvents: 'none', userSelect: 'none', }} className='fs-13 ar-light-color text'>Draw your signature here</div>
                                            )}
                                            {/* <button onClick={saveDrawnSignature}> Save</button> */}
                                        </div>
                                    </div>

                                </Tab.Pane>

                                <Tab.Pane eventKey='Upload'>
                                    <div className="p-2 ar_content">
                                        {!uploadedImage &&
                                            (<div className={` p-0 cursor-pointer upload_file`}>
                                                <input
                                                    ref={uploadRef}
                                                    type="file"
                                                    className='opacity-0 visually-hidden'
                                                    // accept="image/*"
                                                    accept=".png,.jpg,.jpeg"
                                                    id='PatientFile'
                                                    name="PatientFile"
                                                    onChange={handleUpload}
                                                />

                                                <label className="d-flex align-items-center justify-content-center h-100 w-100" htmlFor='PatientFile'>
                                                    <div className="d-flex flex-column gap-6 align-items-center">
                                                        <span class="icon-Group-1000002927 fs-20"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                                                        <p className='f-13 ar-light-color text lh-normal' > Upload signature File here</p>
                                                        <p className='f-10 color-95 text lh-normal' > Formats: PNG and JPG</p>
                                                    </div>
                                                </label>
                                            </div>)}
                                        {uploadedImage &&
                                            (<div className="d-flex gap-10 justify-content-between">
                                                <div className="w-100 text-center">
                                                    <img
                                                        src={uploadedImage}
                                                        className=""
                                                        alt="Uploaded Signature"
                                                        style={{ maxHeight: 235, maxWidth: 235 }}
                                                    />
                                                </div>
                                                <i className="icon-delete text-danger fs-17" onClick={() => setUploadedImage(null)}></i>
                                            </div>)}
                                        {/* <button onClick={saveUploadedSignature}> Save</button> */}
                                    </div>
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </>}

                {props?.isOpenedFrom === "PatientDefaultSignature" ?
                    <div className="mt-12 px-10">
                        <div className="d-flex align-items-center gap-2">
                            <p className='text font-m'>Default Signature for Forms</p>
                            <div className="pe-0 m-0 insurance_radio_btn ar-toggle">
                                <div className="form-check form-switch radio_button mh-unset m-0 d-flex">
                                    <input
                                        className="form-check-input float-none m-0"
                                        type="checkbox"
                                        name="DefaultSignature"
                                        id="DefaultSignature"
                                        checked={isDefaultSignature}
                                        onChange={(e) => setIsDefaultSignature(e.target.checked)}
                                    />
                                </div>
                            </div>
                        </div>
                        <p className="text fs-10">When enabled, this signature will be automatically applied to forms.</p>
                    </div>
                    : null}
            </div>
        </>
    );
});

export default SignatureConsentForm;

const SignPreview = ({ BucketPath, ...props }) => {
    const API_URL_Wasabi = enumUtil.controller.Wasabi;
    const [imgFile, setImgFile] = useState(null);

    useEffect(() => {
        ViewFile(BucketPath);
    }, [])

    const ViewFile = (BucketPath) => {
        if (!isNull(BucketPath)) {
            // setPdfFile(null);
            // setTxtFile(null);
            setImgFile(null);
            props?.setIsLoading?.(true);
            ServerRequestPublic(
                API_URL_Wasabi + "/DownloadFile",
                "post",
                {
                    BucketPath: BucketPath,
                },
                "Download"
            )
                .then((response) => {
                    props?.setIsLoading?.(false);

                    if (response.type === "application/txt") {
                        // const blob = response;
                        // const reader = new FileReader();
                        // reader.onload = () => {
                        //     const content = reader.result;
                        //     setTxtFile(content);
                        // };

                        // reader.readAsText(blob, "utf-8");
                    } else if (["application/png", "application/jpg", "application/jpeg", "application/tiff"].includes(response.type)) {
                        const blob = response;
                        const objectURL = URL.createObjectURL(blob);
                        setImgFile(objectURL);
                    } else if (response.type === "application/pdf") {
                        // const blob = response;
                        // const objectURL = URL.createObjectURL(blob);
                        // setPdfFile(objectURL);
                    } else {
                        // let file = new Blob([response]);
                        // const fileUrl = URL.createObjectURL(file);
                        // setPdfFile(fileUrl);
                    }
                    // setModalActive(true);
                })
                .catch((error) => {
                    props?.setIsLoading?.(false);
                    // NotificationHandler("File Not Found", enumUtil.enumtoaster.error);
                });
        }
    };
    return (
        <div className='px-10 sign-preview'>
            <p className='text ar-light-color'>Preview</p>
            <div className="sign-here-box p-2 h-100">
                {!isNull(imgFile) ?
                    <>
                        <div className="d-flex justify-content-center align-items-center">
                            <img
                                src={imgFile}
                                className='mw-100'
                                style={{ maxHeight: '81px' }}
                                alt="Uploaded preview"
                            />
                        </div>
                        {/* <span className="cross-icon d-flex"  onClick={handleRemoveFile}>
                        <i className="icon-x-cros fs-14 dark-clr fw-900"></i>
                    </span> */}
                        <p className="text ar-light-color fs-11 mt-1">Electronically Signed by: {props?.initialDataData?.ProviderSignBy || 'N/A'}</p>
                        <p className="text ar-light-color fs-11">{props?.initialDataData?.ProviderSignatureDate || 'N/A'}</p>
                    </>
                    : <></>
                    // (providerSaveUpdateModal.SignaturePath ?
                    // <>
                    //     <img
                    //         src={`data:image/png;base64,${providerSaveUpdateModal.SignaturePath}`}
                    //         style={{ maxHeight: '81px' }}
                    //         alt="Uploaded preview" />
                    //     <span className="cross-icon d-flex"  onClick={handleRemoveFile}>
                    //         <i className="icon-x-cros fs-14 dark-clr fw-900"></i>
                    //     </span>
                    // </> :
                    // <div className='fs-13 ar-light-color text h-100 w-100 d-flex justify-content-center align-items-center' onClick={() => setIsSign(true)}>Click to add signature...</div>)
                }
            </div>
        </div>)
}
